import { render, staticRenderFns } from "./MaterialChartCard.vue?vue&type=template&id=33ed306c"
import script from "./MaterialChartCard.vue?vue&type=script&lang=js"
export * from "./MaterialChartCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialChartCard.vue?vue&type=style&index=0&id=33ed306c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports